import { useRef, memo } from 'react';
import mapboxgl from 'mapbox-gl';
import { useControl, ControlPosition } from 'react-map-gl';

import { controlLocale } from '~constants/mapControlLocale';
import { MapCustomButtonControl } from '~utils/mapClasses';

export interface ShowTripViewControlProps {
  currentBounds: mapboxgl.LngLatBounds;
  position?: ControlPosition;
}

export const ShowTripViewControl = ({
  currentBounds,
  position,
}: ShowTripViewControlProps): null => {
  const currentBoundsRef = useRef(currentBounds);

  currentBoundsRef.current = currentBounds;

  useControl(
    ({ map }) =>
      new MapCustomButtonControl({
        className: 'mapbox-gl-trip',
        title: controlLocale.ShowTrip,
        eventHandler: () => {
          map.fitBounds(currentBoundsRef.current, {
            padding: 100,
            maxZoom: 12,
          });
        },
      }),
    { position },
  );

  return null;
};

export default memo(ShowTripViewControl);
